module.exports = __webpack_public_path__ + "static/img/50.210cb880.jpg";